import { Paper, LoadingOverlay, Group, Text, Button, Table, ActionIcon } from '@mantine/core';
import { IconPlus, IconEdit, IconTrash } from '@tabler/icons-react';

export default function QuotesSettingsSection({
  loading,
  activeTab,
  quotes,
  fetchQuotes,
  openNewQuote,
  openEditQuote,
  handleDeleteQuote,
}) {
  return (
    <Paper withBorder p="md" radius="md" mt="xs" pos="relative">
      <LoadingOverlay visible={loading && activeTab === 'quotes'} overlayProps={{ radius: 'sm', blur: 2 }} />

      <Group justify="space-between" mb="md">
        <Text fw={700}>Motivasyon Sözleri</Text>
        <Group>
          <Button size="xs" variant="light" onClick={fetchQuotes}>Yenile</Button>
          <Button size="xs" color="blue" leftSection={<IconPlus size={14} />} onClick={openNewQuote}>
            Yeni Söz Ekle
          </Button>
        </Group>
      </Group>

      <Table striped highlightOnHover withTableBorder>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Söz İçeriği</Table.Th>
            <Table.Th style={{ textAlign: 'right', width: '120px' }}>İşlem</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {quotes.map((quote) => (
            <Table.Tr key={quote.id}>
              <Table.Td>
                <Text size="sm" fs="italic">"{quote.content}"</Text>
              </Table.Td>
              <Table.Td style={{ textAlign: 'right' }}>
                <Group gap="xs" justify="flex-end">
                  <ActionIcon color="blue" variant="subtle" onClick={() => openEditQuote(quote)}>
                    <IconEdit size={16} />
                  </ActionIcon>
                  <ActionIcon color="red" variant="subtle" onClick={() => handleDeleteQuote(quote.id)}>
                    <IconTrash size={16} />
                  </ActionIcon>
                </Group>
              </Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Paper>
  );
}